var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFrench({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4384_23974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H150V100H0",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V100H0",
    fill: "#002654"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4384_23974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFrench);
export default __webpack_public_path__ + "static/media/flag_french.c28b7876bac9c034e87e2a3f2b0e698e.svg";
export { ForwardRef as ReactComponent };